import { useNavigate } from "react-router-dom";
import styles from "./Header.module.scss";
import logo from "../../assets/logo.png";

interface HeaderProps {
  selectedTab: string;
  onTabChange: (tab: string) => void;
}

const Header: React.FC<HeaderProps> = () => {
  const navigate = useNavigate();

  return (
    <header className={styles.header}>
      <img
        src={logo}
        alt="Ondoc Logo"
        className={styles.logo}
        onClick={() => navigate("/")}
      />
    </header>
  );
};

export default Header;
